import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import { URLS } from '@wix/da-url';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import { DeviationResourceType } from '../../../types/deviation';
var SubscribedVariant = function (_a) {
    var tier = _a.tier, className = _a.className, _b = _a.size, size = _b === void 0 ? 'medium' : _b, href = _a.href;
    var t = useTranslation().t;
    return (React.createElement(SolidButton, { className: className, size: size, variant: "approval-green", priority: "secondary", href: href, isFakeButton: !href, biData: {
            evid: BiEventType.TIER_UNSUBSCRIBE,
            typeid: DeviationResourceType.TIER,
            itemid: tier.deviationId,
            referral_info: (typeof window !== 'undefined' && window.location.href === URLS.ORDERS
                ? ReferralType.BILLING_PAYMENTS
                : ReferralType.TIER_CARD) || ReferralType.TIER_CARD,
        } }, t('deviation.tier.subscribed')));
};
SubscribedVariant.displayName = 'SubscribedVariant';
export default SubscribedVariant;
//# sourceMappingURL=Subscribed.js.map